import React, { lazy, Suspense } from "react";
import PropTypes from "prop-types";

// assets
import playIconSvg from "../../../images/svg/icons/play-button.svg";

// Components
import Loading from "./Loading";
const ReactPlayer = lazy(() => import("react-player"));

// Helper function to check if the URL is a format ReactPlayer supports.
const isUrlSupported = (url) => {
	if (!url) return false;
	const supportedPatterns =
        /(youtube\.com|youtu\.be|vimeo\.com|wistia\.com|wi\.st|mux\.com|\.mp4|\.webm|\.ogv|\.mp3|\.m3u8|\.mpd)/i;
	return supportedPatterns.test(url);
};


const VideoPlayer = ({ videoUrl, imageUrl }) => {
	const playIcon = <img src={playIconSvg} alt="play" className="play-icon" />;

	const isSupported = isUrlSupported(videoUrl);

	return (
		<>
			{isSupported ? (
				<Suspense fallback={<Loading color={"mustard"} />}>
					<ReactPlayer
						height="100%"
						width="100%"
						src={videoUrl}
						light={imageUrl}
						playIcon={playIcon}
						controls={true}
						config={{
							youtube: {
								playerVars: {
									enablejsapi: 1,
								},
							},
						}}
					/>
				</Suspense>
			) : (
				<div className="video-player__error">
                    Sorry, this video URL is not supported.
				</div>
			)}
		</>
	);
};

VideoPlayer.propTypes = {
	videoUrl: PropTypes.string,
	imageUrl: PropTypes.string,
};

export default VideoPlayer;